// React
import React from 'react'
import PropTypes from 'prop-types'

// Hooks
import { useTranslation } from 'shared/utils/useTranslation'
import { useCart } from 'shop-components/utils/useCart'

// Components
import Logo from 'shop-components/components/MiniCart/components/Logo'

export const PoweredBy = ({ logoWidth }) => {
  const { t } = useTranslation('user')
  const { poweredByLink } = useCart()

  let title = t('user.powered_by_short')
  let href = 'https://booqable.com/?source=Shop&campaign=Cart'

  if (poweredByLink === 'equipment') {
    title = t('user.powered_by_equipment_rental_long')
    href = 'https://booqable.com/industries/equipment-rental-software/?source=Shop&campaign=Cart'
  }

  if (poweredByLink === 'bike') {
    title = t('user.powered_by_bike_rental_long')
    href = 'https://booqable.com/industries/bike-rental-software/?source=Shop&campaign=Cart'
  }

  return (
    <a href={href} target="_blank" title={title} rel="noreferrer">
      <Logo width={logoWidth} />
      {t('user.powered_by_short')}
    </a>
  )
}

PoweredBy.propTypes = {
  logoWidth: PropTypes.string
}
